/**
 * @generated SignedSource<<8bd5c72fe90948580aebf38816ecc237>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type SortEnumType = "ASC" | "DESC" | "%future added value";
export type StudentsSkillAssessmentsFilterInput = {
  assessmentCompletedFrom?: any | null | undefined;
  assessmentCompletedTo?: any | null | undefined;
  assessmentScores?: ReadonlyArray<number> | null | undefined;
  classIds?: ReadonlyArray<string> | null | undefined;
  gradeLevelIds?: ReadonlyArray<string> | null | undefined;
  isActive?: boolean | null | undefined;
  skillCode?: string | null | undefined;
  skillName?: string | null | undefined;
  standardGradeIds?: ReadonlyArray<string> | null | undefined;
  studentName?: string | null | undefined;
  targetGroupIds?: ReadonlyArray<string> | null | undefined;
  userIds?: ReadonlyArray<string> | null | undefined;
};
export type StudentSkillAssessmentSortInput = {
  activityId?: SortEnumType | null | undefined;
  id?: SortEnumType | null | undefined;
  isComplete?: SortEnumType | null | undefined;
  isInferred?: SortEnumType | null | undefined;
  maxScore?: SortEnumType | null | undefined;
  publicUserId?: SortEnumType | null | undefined;
  questionsAttempted?: SortEnumType | null | undefined;
  questionsAvailable?: SortEnumType | null | undefined;
  score?: SortEnumType | null | undefined;
  sessionCompletedOn?: SortEnumType | null | undefined;
  sessionId?: SortEnumType | null | undefined;
  sessionLength?: SortEnumType | null | undefined;
  sessionNumber?: SortEnumType | null | undefined;
  sessionStartedOn?: SortEnumType | null | undefined;
  skill?: SkillSortInput | null | undefined;
  user?: UserSortInput | null | undefined;
};
export type UserSortInput = {
  createdBy?: UserSortInput | null | undefined;
  createdOn?: SortEnumType | null | undefined;
  email?: SortEnumType | null | undefined;
  externalSync?: ExternalSyncSortInput | null | undefined;
  externalSyncId?: SortEnumType | null | undefined;
  firstName?: SortEnumType | null | undefined;
  fullName?: SortEnumType | null | undefined;
  id?: SortEnumType | null | undefined;
  isActive?: SortEnumType | null | undefined;
  isMetabaseAccessEnabled?: SortEnumType | null | undefined;
  isMetabaseEmailEnabled?: SortEnumType | null | undefined;
  isObfuscated?: SortEnumType | null | undefined;
  lastName?: SortEnumType | null | undefined;
  lastNameFirst?: SortEnumType | null | undefined;
  modifiedBy?: UserSortInput | null | undefined;
  modifiedOn?: SortEnumType | null | undefined;
  owner?: UserSortInput | null | undefined;
  publicUserId?: SortEnumType | null | undefined;
};
export type ExternalSyncSortInput = {
  id?: SortEnumType | null | undefined;
  isObfuscated?: SortEnumType | null | undefined;
  lastUpdatedOn?: SortEnumType | null | undefined;
  source?: SortEnumType | null | undefined;
};
export type SkillSortInput = {
  assessmentInfo?: SortEnumType | null | undefined;
  code?: SortEnumType | null | undefined;
  context?: SortEnumType | null | undefined;
  createdBy?: UserSortInput | null | undefined;
  createdOn?: SortEnumType | null | undefined;
  difficulty?: SortEnumType | null | undefined;
  essentialQuestion?: SortEnumType | null | undefined;
  id?: SortEnumType | null | undefined;
  isActive?: SortEnumType | null | undefined;
  lessonInfo?: SortEnumType | null | undefined;
  mapCutoffScore?: SortEnumType | null | undefined;
  modifiedBy?: UserSortInput | null | undefined;
  modifiedOn?: SortEnumType | null | undefined;
  name?: SortEnumType | null | undefined;
  progressionNotes?: SortEnumType | null | undefined;
  summary?: SortEnumType | null | undefined;
};
export type MonitoringSkillAssessmentsQuery$variables = {
  after?: string | null | undefined;
  before?: string | null | undefined;
  filter: StudentsSkillAssessmentsFilterInput;
  first?: number | null | undefined;
  last?: number | null | undefined;
  order?: ReadonlyArray<StudentSkillAssessmentSortInput> | null | undefined;
  skip?: boolean | null | undefined;
};
export type MonitoringSkillAssessmentsQuery$data = {
  readonly studentsSkillAssessments?: {
    readonly nodes: ReadonlyArray<{
      readonly id: string;
      readonly maxScore: number;
      readonly score: number;
      readonly sessionCompletedOn: any;
      readonly sessionNumber: number;
      readonly skill: {
        readonly code: string | null | undefined;
        readonly id: string;
        readonly name: string | null | undefined;
      } | null | undefined;
      readonly user: {
        readonly firstName: string | null | undefined;
        readonly id: string;
        readonly lastName: string | null | undefined;
        readonly publicUserId: string | null | undefined;
        readonly roles: ReadonlyArray<{
          readonly id: string;
          readonly name: string | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
    }> | null | undefined;
    readonly pageInfo: {
      readonly endCursor: string | null | undefined;
      readonly hasNextPage: boolean;
      readonly hasPreviousPage: boolean;
      readonly startCursor: string | null | undefined;
    };
    readonly totalCount: number;
  } | null | undefined;
};
export type MonitoringSkillAssessmentsQuery = {
  response: MonitoringSkillAssessmentsQuery$data;
  variables: MonitoringSkillAssessmentsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "before"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filter"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "last"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "order"
},
v6 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "skip"
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v9 = [
  {
    "condition": "skip",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
          },
          {
            "kind": "Variable",
            "name": "before",
            "variableName": "before"
          },
          {
            "kind": "Variable",
            "name": "filter",
            "variableName": "filter"
          },
          {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
          },
          {
            "kind": "Variable",
            "name": "last",
            "variableName": "last"
          },
          {
            "kind": "Variable",
            "name": "order",
            "variableName": "order"
          }
        ],
        "concreteType": "StudentSkillAssessmentNodeConnection",
        "kind": "LinkedField",
        "name": "studentsSkillAssessments",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "StudentSkillAssessmentNode",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sessionNumber",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UserNode",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "firstName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "publicUserId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RoleNode",
                    "kind": "LinkedField",
                    "name": "roles",
                    "plural": true,
                    "selections": [
                      (v7/*: any*/),
                      (v8/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SkillNode",
                "kind": "LinkedField",
                "name": "skill",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "score",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "maxScore",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sessionCompletedOn",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "MonitoringSkillAssessmentsQuery",
    "selections": (v9/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/),
      (v4/*: any*/),
      (v1/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Operation",
    "name": "MonitoringSkillAssessmentsQuery",
    "selections": (v9/*: any*/)
  },
  "params": {
    "cacheID": "c423b4e8cc6462a02e1d2b63c4ef0fc6",
    "id": null,
    "metadata": {},
    "name": "MonitoringSkillAssessmentsQuery",
    "operationKind": "query",
    "text": "query MonitoringSkillAssessmentsQuery(\n  $filter: StudentsSkillAssessmentsFilterInput!\n  $first: Int\n  $after: String\n  $last: Int\n  $before: String\n  $order: [StudentSkillAssessmentSortInput!]\n  $skip: Boolean = false\n) {\n  studentsSkillAssessments(filter: $filter, first: $first, order: $order, last: $last, before: $before, after: $after) @skip(if: $skip) {\n    nodes {\n      id\n      sessionNumber\n      user {\n        id\n        firstName\n        lastName\n        publicUserId\n        roles {\n          id\n          name\n        }\n      }\n      skill {\n        id\n        name\n        code\n      }\n      score\n      maxScore\n      sessionCompletedOn\n    }\n    totalCount\n    pageInfo {\n      endCursor\n      hasNextPage\n      hasPreviousPage\n      startCursor\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a9414d99e333971941adfedaca930be4";

export default node;
